import { type PackageManager } from "~/utils/getUserPkgManager.js";

// Turning this into a const allows the list to be iterated over for programatically creating prompt options
// Should increase extensability in the future

export interface InstallerOptions {
  frontendDir: string;
  pkgManager: PackageManager;
  noInstall: boolean;
  projectName?: string;
}

export type AvailableFlavours =
  | "oauth-proxy"
  | "oauth-proxy-custom-ui"
  | "local-auth"
  | "local-auth-custom-ui"
  | "backend-only"
  | "backend-only-no-db"; // | "go" | "java"

export type FlavourDisplay = {
  value: AvailableFlavours;
  name: string;
  description: string;
};

export const flavourDisplayList: FlavourDisplay[] = [
  {
    value: "oauth-proxy",
    name: "oauth-proxy (default)",
    description: "Carbon UI + auth via oauth proxy & AppID",
  },
  // {
  //   value: "go",
  //   name: "Go",
  //   description: "full-stack-cen-template with Go backend",
  // },
  // {
  //   value: "java",
  //   name: "Java",
  //   description: "full-stack-cen-template with Java backend",
  // },
  {
    value: "oauth-proxy-custom-ui",
    name: "oauth-proxy-custom-ui",
    description: "shadcn UI + auth via oauth proxy & AppID",
  },
  {
    value: "local-auth",
    name: "local-auth",
    description: "Carbon UI + built-in auth",
  },
  {
    value: "local-auth-custom-ui",
    name: "local-auth-custom-ui",
    description: "shadcn UI + built-in auth",
  },
  {
    value: "backend-only",
    name: "backend-only",
    description: "API-only with API key auth",
  },
  {
    value: "backend-only-no-db",
    name: "backend-only-no-db",
    description: "API-only with API key auth, no database",
  },
];
